<template lang="pug">
div
  md-input-container(:class='{ "md-input-invalid" : formSubmitted && validations.pulseHost.$invalid }')
    label Pulse Host
    md-input(v-model='ooyalaParams.pulseHost')
    span.md-error(v-if='formSubmitted && !validations.pulseHost.required') This field is required
    span.md-error(v-if='formSubmitted && !validations.pulseHost.url') Invalid URL
  md-input-container(:class='{ "md-input-invalid" : formSubmitted && validations.category.$invalid }')
    label Category
    md-input(v-model='ooyalaParams.category')
    span.md-error(v-if='formSubmitted && !validations.category.required') This field is required
</template>

<script>
  export default {
    props: {
      ooyalaParams: {
        type: Object,
        required: true,
        default: () => ({})
      },
      formSubmitted: {
        type: Boolean,
        default: false
      },
      validations: {
        type: Object,
        required: true,
        default: () => ({})
      }
    }
  };
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/shared-components/Ooyala.vue